import { render } from "./SAGASUTyping.vue?vue&type=template&id=782ff6ff"
import script from "./SAGASUTyping.vue?vue&type=script&lang=js"
export * from "./SAGASUTyping.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__